import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/lib/lang";
import SiteLayout from "@/components/layout/SiteLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProjectsPage from "@/pages/ProjectsPage";
import JournalPage from "@/pages/JournalPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import NotFoundPage from "@/pages/NotFoundPage";
import SGBPage from "@/pages/SGBPage";
import SGBLegalPage from "@/pages/SGBLegalPage";
import PressKitPage from "@/pages/PressKitPage";
import DokumentePage from "@/pages/DokumentePage";
import AtelierPage from "@/pages/AtelierPage";
import { SlidesIndexPage, SlidesDeckPage } from "@/pages/SlidesPage";
import ImageProtection from "@/components/layout/ImageProtection";
import StudioToSGBPill from "@/components/layout/StudioToSGBPill";
import CookieBanner from "@/components/layout/CookieBanner";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
};

const StudioRoutes = () => (
  <SiteLayout>
    <StudioToSGBPill />
    <Routes>
      {/* patrice.studio home now lives under /studio so it is decoupled from the SGB root */}
      <Route path="/studio" element={<HomePage />} />
      <Route path="/ueber-mich" element={<AboutPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/projekte" element={<ProjectsPage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/journal" element={<JournalPage />} />
      <Route path="/kontakt" element={<ContactPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/presse" element={<PressKitPage />} />
      <Route path="/press" element={<PressKitPage />} />
      <Route path="/slides" element={<SlidesIndexPage />} />
      <Route path="/slides/:deck" element={<SlidesDeckPage />} />
      <Route path="/dokumente" element={<DokumentePage />} />
      <Route path="/docs" element={<DokumentePage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </SiteLayout>
);

function App() {
  return (
    <div className="App">
      <a
        href="#main-content"
        data-testid="skip-link"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[120] focus:px-4 focus:py-3 focus:bg-depth focus:text-canvas focus:font-mono focus:text-[0.65rem] focus:tracking-[0.32em] focus:uppercase focus:outline focus:outline-2 focus:outline-signal"
      >
        Zum Inhalt springen
      </a>
      <LanguageProvider>
        <BrowserRouter>
          <ImageProtection />
          <CookieBanner />
          <ScrollToTop />
          <main id="main-content">
          <Routes>
            {/* SGB is now the root of sichtbargutbewertet.de — completely
                isolated, no <SiteLayout> wrapping. */}
            <Route path="/" element={<SGBPage />} />
            {/* SGB Legal pages */}
            <Route path="/sgb/impressum" element={<SGBLegalPage kind="imprint" />} />
            <Route path="/sgb/datenschutz" element={<SGBLegalPage kind="privacy" />} />
            <Route path="/sgb/agb" element={<SGBLegalPage kind="terms" />} />
            <Route path="/sgb/widerruf" element={<SGBLegalPage kind="withdrawal" />} />
            <Route path="/sgb" element={<SGBPage />} />
            <Route path="/sgb/*" element={<SGBPage />} />
            {/* Root-level legal aliases — always SGB on this domain */}
            <Route path="/impressum" element={<SGBLegalPage kind="imprint" />} />
            <Route path="/datenschutz" element={<SGBLegalPage kind="privacy" />} />
            <Route path="/agb" element={<SGBLegalPage kind="terms" />} />
            <Route path="/widerruf" element={<SGBLegalPage kind="withdrawal" />} />
            {/* Emmis Atelier — private materials, not in navigation */}
            <Route path="/atelier" element={<AtelierPage />} />
            {/* patrice.studio universe — under /studio and old route paths */}
            <Route path="*" element={<StudioRoutes />} />
          </Routes>
          </main>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
